import { render, staticRenderFns } from "./webtrader-header.vue?vue&type=template&id=713b5b0a&scoped=true&"
import script from "./webtrader-header.vue?vue&type=script&lang=ts&"
export * from "./webtrader-header.vue?vue&type=script&lang=ts&"
import style0 from "./webtrader-header.vue?vue&type=style&index=0&id=713b5b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b5b0a",
  null
  
)

export default component.exports